import React, { useState, useEffect } from 'react';
import { Container, ListGroup, Spinner, Alert, Card } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import config from '../config';

function RecentGreenDots({ handleSearch }) {
  const [symbols, setSymbols] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    const fetchSymbols = async () => {
      try {
        const response = await fetch(`${config.apiUrl}/api/v1/analysis/recent-green-dots`);
        if (!response.ok) {
          throw new Error('Failed to fetch symbols');
        }
        const data = await response.json();
        setSymbols(data);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchSymbols();
  }, []);

  return (
    <Container className="mt-5">
      <Card className="shadow-sm">
        <Card.Header as="h5" className="text-center bg-primary text-white">Stocks with Green Dot Indicators in the last 5 days</Card.Header>
        <Card.Body>
          {loading ? (
            <Spinner animation="border" role="status">
              <span className="sr-only">Loading...</span>
            </Spinner>
          ) : error ? (
            <Alert variant="danger">{error}</Alert>
          ) : symbols.length === 0 ? (
            <Alert variant="info">No symbols found with recent green dots.</Alert>
          ) : (
            <ListGroup>
              {symbols.map((symbol, index) => (
                <ListGroup.Item key={index}>
                  <a href="." onClick={(e) => { e.preventDefault(); handleSearch(symbol); }}>{symbol}</a>
                </ListGroup.Item>
              ))}
            </ListGroup>
          )}
        </Card.Body>
      </Card>
    </Container>
  );
}

export default RecentGreenDots;
